<template>
  <div>
    <v-dialog v-model="dialog" max-width="350">
      <v-form :id="feedCommentForm" v-model="valid" ref="form" lazy-validation>
        <v-card>
          <v-container>
            <h2 class="text-xs-center">{{$t('feeds.feed_comment')}}</h2>
            <v-icon class="mr-1">mdi-blank</v-icon>
            <v-layout row justify-start>
              <v-text-field
                :id="feedCommentTextField"
                v-model="feedComments"
                class="mr-4 pt-1"
                clearable
                required
                multi-line
                rows="5"
                :rules="requiredRule"
                :placeholder="$t('feeds.comment')">
              </v-text-field>
            </v-layout>
            <v-layout row>
              <v-flex xs4 pt-0><h3>{{this.feedTitle}}</h3></v-flex>
              <v-flex xs4 pt-0><h3>{{this.username}}</h3></v-flex>
              <v-flex xs4 pt-0><h3>{{this.commentDate}}</h3></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4 pt-0> <div class="caption mb-1">{{$t('feeds.comment_feed')}}</div></v-flex>
              <v-flex xs4 pt-0><div class="caption mb-1">{{$t('feeds.comment_author')}}</div></v-flex>
              <v-flex xs4 pt-0><div class="caption mb-1">{{$t('feeds.comment_date')}}</div></v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-layout row justify-center class="pt-1 pb-1">
              <v-btn :id="feedCommentCancelBtn" @click="closeModal">{{$t('feeds.comment_cancel')}}</v-btn>
              <v-btn :id="feedCommentSubmitBtn" @click="runFeedWithComments" color="primary">{{$t('feeds.comment_submit')}}</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
  import Helpers from '../../mixins/Helpers'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT } from '../../store/mutation-types'
  import { RUN_FEED_WITH_COMMENTS } from '../../store/action-types'
  import { informationTexts } from '../../store/modules/information'
  import moment from 'moment-es6'

  export default {
    name: 'feed-run-comment',
    mixins: [Helpers],
    data () {
      return {
        commentDate: moment().format('DD/MM/YYYY'),
        today: moment().format('YYYY-MM-DD'),
        valid: false,
        comment: '',
        requiredRule: [v => !!v || this.$t('field_required')]
      }
    },
    methods: {
      closeModal () {
        this.comment = ''
        this.$emit('update:dialog', false)
        this.$refs.form.reset()
        this.setSnackBarText(informationTexts.FEED_RUN_CANCEL)
        this.setSnackBar(true)
      },
      runFeedWithComments () {
        if (this.$refs.form.validate()) {
          const payload = {
            processId: this.feed.processId,
            scheduleId: this.feed.scheduleId,
            date: this.today,
            comment: this.feedComments,
            fromDate: this.feed.processScheduleOffsetDays < 0 ? this.runDate : null
          }
          this.$store.dispatch(RUN_FEED_WITH_COMMENTS, payload)
          this.$emit('update:dialog', false)
          this.comment = ''
          this.$refs.form.reset()
        }
      },
      ...mapActions({
        runFeed: RUN_FEED_WITH_COMMENTS
      }),
      ...mapMutations({
        setSnackBarText: SET_INFORMATION_SNACKBAR_TEXT,
        setSnackBar: SET_INFORMATION_SNACKBAR_STATE
      })
    },
    computed: {
      ...mapState({
        username: state => state.profile.username
      }),
      feedCommentCancelBtn () {
        return `feed-comment-cancel-btn-${this.feed.scheduleId}`
      },
      feedCommentSubmitBtn () {
        return `feed-comment-submit-btn-${this.feed.scheduleId}`
      },
      feedCommentTextField () {
        return `feeds-comment-field-${this.feed.scheduleId}`
      },
      feedCommentForm () {
        return `feed-comment-form-${this.feed.scheduleId}`
      },
      feedComments: {
        get () {
          return this.comment
        },
        set (value) {
          if ((value) && value.length > 0) {
            this.comment = value
          }
        }
      }
    },
    props: {
      dialog: {
        default: false
      },
      feed: {
        type: Object
      },
      feedTitle: {
        type: String
      },
      runDate: {
        type: String
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/monitor/FeedRunComment.vue